export const testimonialsData = [
  {
    id: 1,
    name: "Magdalena",
    company: "Salon Kosmetologii Estetycznej",
    text: "Nareszcie moja strona wygląda tak luksusowo, jak moje usługi. Grafiki są obłędne – nikt w mojej branży nie ma nic podobnego. Najbardziej zaskoczyło mnie to, że wszystko było gotowe w dwa dni.",
    rating: 5,
  },
  {
    id: 2,
    name: "Tomasz",
    company: "Doradztwo Biznesowe",
    text: "Moja poprzednia strona wiecznie się zacinała. Ta od Klary Queen działa błyskawicznie, nawet na telefonie. Klienci od razu zauważyli zmianę. Pełen profesjonalizm i zero lania wody.",
    rating: 5,
  },
  {
    id: 3,
    name: "Agnieszka",
    company: "Biuro Architektoniczne",
    text: "Zależało mi na estetyce, która odda jakość moich projektów. Studio zrozumiało moją wizję w punkt. Strona jest elegancka, czysta i bardzo nowoczesna. Świetny kontakt na każdym etapie.",
    rating: 5,
  },
  {
    id: 4,
    name: "Piotr",
    company: "Agencja Eventowa Premium",
    text: "Szybkość realizacji w tym studiu to jakiś kosmos. Podczas gdy inni dopiero przygotowywali oferty, tutaj strona już była gotowa do publikacji. Wszystko działa idealnie, bez żadnych błędów.",
    rating: 5,
  },
  {
    id: 5,
    name: "Katarzyna",
    company: "Coaching & Mentoring",
    text: "Byłam sceptyczna, czy w 48h da się zrobić coś porządnego. Myliłam się. Strona jest piękna, unikalna i co najważniejsze – klienci zaczęli pisać do mnie sami. To była świetna inwestycja.",
    rating: 5,
  },
  {
    id: 6,
    name: "Robert",
    company: "Firma Logistyczna",
    text: "Konkretnie i na temat. Dostałem nowoczesne narzędzie, które buduje prestiż mojej firmy. Nie muszę się martwić o żadne wirusy czy błędy – wszystko po prostu działa jak należy.",
    rating: 5,
  },
  {
    id: 7,
    name: "Joanna",
    company: "Kancelaria Prawna",
    text: "Bardzo merytoryczne podejście. Strona jest minimalistyczna, ale bije od niej profesjonalizm. Duży plus za cierpliwość przy dobieraniu grafik – efekt końcowy jest idealny.",
    rating: 5,
  },
  {
    id: 8,
    name: "Marek",
    company: "Studio Treningu Personalnego",
    text: "Większość stron w mojej branży wygląda tak samo. Moja od razu się wyróżnia dzięki tym grafikom. Jest dynamiczna, szybka i po prostu chce się na niej zostać dłużej.",
    rating: 5,
  },
  {
    id: 9,
    name: "Ewa",
    company: "Projektantka Wnętrz",
    text: "Cenię sobie estetykę, a Studio Klara Queen dostarczyło mi projekt, który jest po prostu piękny. Wszystko dopięte na ostatni guzik w ekspresowym tempie. Polecam każdemu.",
    rating: 5,
  },
  {
    id: 10,
    name: "Łukasz",
    company: "Sklep Internetowy (Nisza Premium)",
    text: "Przejście na nową stronę to była ulga. Wszystko ładuje się w ułamku sekundy, a proces zakupowy jest płynny. Widać, że zespół zna się na rzeczy i nie idzie na łatwiznę.",
    rating: 5,
  },
  {
    id: 11,
    name: "Karolina",
    company: "Fotografia Ślubna",
    text: "Jako fotograf zwracam uwagę na każdy piksel. Jestem pod ogromnym wrażeniem, jak dobrze dobrano oprawę wizualną. Strona jest lekka, szybka i bardzo stylowa.",
    rating: 5,
  },
  {
    id: 12,
    name: "Andrzej",
    company: "Usługi Finansowe",
    text: "Szukałem solidnego partnera i nie zawiodłem się. Strona jest bezpieczna, wygląda nowocześnie i buduje zaufanie od pierwszej sekundy. Żadnych problemów z terminami.",
    rating: 5,
  },
  {
    id: 13,
    name: "Natalia",
    company: "Klinika Stomatologiczna",
    text: "Zależało nam na nowoczesnym wizerunku. Strona, którą otrzymaliśmy, jest przejrzysta i bardzo intuicyjna dla pacjentów. Proces wdrożenia trwał niesamowicie krótko.",
    rating: 5,
  },
  {
    id: 14,
    name: "Michał",
    company: "Produkcja Mebli na Wymiar",
    text: "Konkretny kontakt i szybka realizacja. Strona świetnie eksponuje nasze realizacje. Podoba mi się, że nie muszę tracić czasu na techniczne detale – studio zajęło się wszystkim.",
    rating: 5,
  },
  {
    id: 15,
    name: "Daria",
    company: "Marka Odzieżowa",
    text: "Moja marka w końcu zyskała oprawę, na jaką zasługiwała. Grafiki są unikalne, a strona działa bez zarzutu. Całość wygląda bardzo prestiżowo i nowocześnie.",
    rating: 5,
  },
];
